// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isThursday/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isThursday = convertToFP(fn, 1);
export default isThursday;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isThursday/index.js
// module id = 942
// module chunks = 0